export default __webpack_public_path__ + "static/media/thailand_powerline_transmission.4fd4e642.png";